export default __webpack_public_path__ + "assets/theia-3.7668d5b8.png";